import { useEffect } from "react";
import useFacility from "./useFacility";
import { PURCHASE } from "../../app/routes";

export default function useSuccessRedirection() {
  const facilityIds = useFacility();

  useEffect(() => {
    // W trybie standalone (bez iframe) nie używamy tego mechanizmu –
    // obsługę powrotu z płatności realizuje useNormalizePaymentReturnUrl
    if (typeof window !== "undefined" && window.self === window.top) {
      return;
    }

    setTimeout(() => {
      const parentPageUrl = sessionStorage.getItem("parentPageUrl");

      if (parentPageUrl && parentPageUrl.includes("success") && window.location.pathname !== PURCHASE) {
        window.open(`${PURCHASE}?id=${facilityIds}`, "_self");
      }
    }, 2000);

    //eslint-disable-next-line
  }, [facilityIds]);

  // useEffect(() => {
  //   let checkCount = 0;
  //   const maxChecks = 10;

  //   const checkParentPageUrl = () => {
  //     const parentPageUrl = sessionStorage.getItem("parentPageUrl");
  //     console.log("parentPageUrl", parentPageUrl);
  //     if (parentPageUrl && parentPageUrl.includes("success") && window.location.pathname !== PURCHASE) {
  //       console.log("przechodze na PURCHASE");
  //       window.open(`${PURCHASE}?id=${facilityIds}`, "_self");
  //       clearInterval(intervalId);
  //     }

  //     checkCount += 1;
  //     if (checkCount >= maxChecks) {
  //       clearInterval(intervalId);
  //     }
  //   };
  //   checkParentPageUrl();
  //   const intervalId = setInterval(checkParentPageUrl, 1000);
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [facilityIds]);
}
